import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ScanSearch, FileText, Heart, Home, Radio, ListChecks } from "lucide-react";

export default function Nav() {
  const { pathname } = useLocation();
  const isActive = (p) => pathname === p || (p !== "/" && pathname.startsWith(p));

  return (
    <header
      data-testid="app-nav"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[hsl(var(--paper)/0.85)] border-b border-[hsl(var(--rule))]"
    >
      <div className="max-w-6xl mx-auto px-3 sm:px-8 py-3 sm:py-4 flex items-center justify-between gap-2 sm:gap-4">
        <Link to="/" className="flex items-center gap-2 group min-w-0 shrink" data-testid="nav-logo">
          <div className="relative w-8 h-8 rounded-sm bg-[hsl(var(--ink))] flex items-center justify-center shrink-0">
            <ScanSearch className="w-4 h-4 text-[hsl(var(--paper))]" strokeWidth={2.25} />
          </div>
          <div className="flex-col leading-none min-w-0 hidden xs:flex sm:flex">
            <span className="font-serif text-[0.95rem] sm:text-[1.05rem] font-semibold tracking-tight whitespace-nowrap truncate">
              Measure <span className="italic">X-Ray</span>
            </span>
            <span className="text-[0.625rem] font-mono uppercase tracking-[0.18em] text-[hsl(var(--ink-muted))] mt-0.5 whitespace-nowrap hidden md:block">
              Bills + ballot measures
            </span>
          </div>
        </Link>

        <nav className="flex items-center gap-1 shrink-0">
          <Link
            to="/"
            data-testid="nav-home"
            className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
              pathname === "/"
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--paper))]"
                : "text-[hsl(var(--ink-2))] hover:bg-[hsl(var(--paper-2))]"
            }`}
          >
            <Home className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">New Scan</span>
            <span className="sm:hidden text-xs">Scan</span>
          </Link>
          <Link
            to="/measures/browse"
            data-testid="nav-browse-measures"
            className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
              pathname === "/measures/browse"
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--paper))]"
                : "text-[hsl(var(--ink-2))] hover:bg-[hsl(var(--paper-2))]"
            }`}
          >
            <ListChecks className="w-3.5 h-3.5" />
            <span className="hidden sm:inline text-sm">Browse</span>
            <span className="sm:hidden text-xs">Browse</span>
          </Link>
          <Link
            to="/measures"
            data-testid="nav-measures"
            className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
              isActive("/measures") && pathname !== "/measures/browse"
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--paper))]"
                : "text-[hsl(var(--ink-2))] hover:bg-[hsl(var(--paper-2))]"
            }`}
          >
            <FileText className="w-3.5 h-3.5" />
            <span className="text-sm">Measures</span>
          </Link>
          <Link
            to="/recent-bills"
            data-testid="nav-recent-bills"
            className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
              isActive("/recent-bills")
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--paper))]"
                : "text-[hsl(var(--ink-2))] hover:bg-[hsl(var(--paper-2))]"
            }`}
          >
            <Radio className="w-3.5 h-3.5" />
            <span className="hidden sm:inline text-sm">New Bills</span>
            <span className="sm:hidden text-xs">New</span>
          </Link>
          <Link
            to="/support"
            data-testid="nav-support"
            className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
              isActive("/support")
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--paper))]"
                : "text-[hsl(var(--ink-2))] hover:bg-[hsl(var(--paper-2))]"
            }`}
          >
            <Heart className="w-3.5 h-3.5" />
            <span className="text-sm">Support</span>
          </Link>
        </nav>
      </div>
    </header>
  );
}
